import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSpeckleImportUIStore = defineStore('speckle-import-ui', () => {
  const showDialog = ref(false)

  function toggleDialog() {
    showDialog.value = !showDialog.value
  }

  return {
    showDialog,
    toggleDialog
  }
})
